import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import { TimetableTimeSlotAllData } from '../fragments';

export default gql`
query AdminTimetableSlotsList(
    $filters: TimetableTimeSlotsFilters,
    $sortBy: TimetableTimeSlotsOrder
    $count: Int!,
    $page: Int
) {
    adminTimetableTimeSlots(
        filters: $filters,
        sortBy: $sortBy,
        first: $count,
        page: $page
    ) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...TimetableTimeSlotAllData
        }
    }
}
${PaginatorInfoFragment}
${TimetableTimeSlotAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminTimetableSlots.ts